import { render, staticRenderFns } from "./LatestDevelopmentsBack.vue?vue&type=template&id=38d43044&scoped=true&"
import script from "./LatestDevelopmentsBack.vue?vue&type=script&lang=js&"
export * from "./LatestDevelopmentsBack.vue?vue&type=script&lang=js&"
import style0 from "./LatestDevelopmentsBack.vue?vue&type=style&index=0&id=38d43044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d43044",
  null
  
)

export default component.exports